module.exports = __webpack_public_path__ + "static/img/thumb-02.1d208b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/thumb/thumb-02.png
// module id = fmzp
// module chunks = 31